import './columns-modal.scss';

(($) => {
    function initColumnsModal() {
        console.log("Colonnes modal OK");
    }
    if ($("body").hasClass("wp-admin")) {
        $(document).on("initColumnsModal", initColumnsModal);
    } else {
        $(document).ready(initColumnsModal);
    }
})(jQuery);